import { takeEvery, put, select } from 'redux-saga/effects';
import { push } from 'connected-react-router';
// action types
import { SUBMIT_STEP, UPDATE_STEP } from '../reducers/completedSteps';
// actions
import { updateProgress } from '../reducers/auth';
import { recoveryShouldBeUpdated } from '../reducers/recovery';
import { openModal } from '../reducers/modal';
import { getProgram } from '../reducers/program';
// utils
import get from 'lodash.get';

/* selector */
export const getUserProgress = state => get(state.auth.user, 'progress', 0);
export const getLastModuleSteps = state =>
  get(state, 'program.program.programmodules.7.step_count');
export const getRelapseStep = state =>
  get(state, 'auth.user.progress.relapsemodule');

/* worker */
function* onStepSubmit({ payload: { meta } }) {
  const progress = yield select(getUserProgress);
  let stepCountOnLast = yield select(getLastModuleSteps);

  if (!stepCountOnLast && meta.user_progress.module === 8) {
    yield put(getProgram());
    stepCountOnLast = yield select(getLastModuleSteps);
  }

  const currentRelapseStep = yield select(getRelapseStep);

  const isLastStep =
    meta.user_progress.module === 8 &&
    meta.user_progress.step > stepCountOnLast &&
    meta.user_progress.relapsemodule === currentRelapseStep;

  const isCongratulation =
    meta.user_progress.module > progress.module || isLastStep;

  if (isCongratulation) {
    yield put(push(`/congratulation?module=${progress.module}`));
  }
  if (meta.user_progress.relapsemodule < progress.relapsemodule) {
    yield put(push(`/congratulation?module=R`));
  }
  if (meta.user_progress.module === 1 && progress.module === 0) {
    if (!progress.subscription) {
      // yield put(openModal('BILLING'));
    }

    if (progress.subscription) {
      yield put(
        openModal('CHECK_IN', {
          type: 'weekly',
        })
      );
    }
  }
  yield put(recoveryShouldBeUpdated());
  yield put(updateProgress(meta.user_progress));
}

function* onStepUpdate() {
  yield put(recoveryShouldBeUpdated());
}

/* watcher */
function* watchModuleActions() {
  yield takeEvery(`${SUBMIT_STEP}_SUCCESS`, onStepSubmit);
  yield takeEvery(`${UPDATE_STEP}_SUCCESS`, onStepUpdate);
}

export default watchModuleActions;



// WEBPACK FOOTER //
// ./src/redux/sagas/module.js